import { useEffect, useRef } from "react";

/**
 * Перезагружает данные, когда пользователь возвращается в приложение:
 * возврат из фона (iOS/Android — visibilitychange), фокус окна в браузере.
 * Чаще, чем раз в minIntervalMs, не дёргаем — чтобы не молотить API
 * при быстром переключении между вкладками.
 */
export function useRefreshOnResume(onResume, minIntervalMs = 30000) {
  const cbRef = useRef(onResume);
  cbRef.current = onResume;
  const lastRef = useRef(Date.now());

  useEffect(() => {
    const maybeRefresh = () => {
      if (document.visibilityState !== "visible") return;
      const now = Date.now();
      if (now - lastRef.current < minIntervalMs) return;
      lastRef.current = now;
      cbRef.current();
    };
    document.addEventListener("visibilitychange", maybeRefresh);
    window.addEventListener("focus", maybeRefresh);
    return () => {
      document.removeEventListener("visibilitychange", maybeRefresh);
      window.removeEventListener("focus", maybeRefresh);
    };
  }, [minIntervalMs]);
}

export default useRefreshOnResume;
